import React from 'react'
import Grid from '@material-ui/core/Grid'
import {
  TopicsDetailContainer,
  DetailsHeading, DetailsHardRule
} from './styles'
import ProductSummary from '../ProductSummary'
import TopicsDetailList from '../TopicsDetailList'
import { groupSubtopics } from './utilities'

const TopicsDetailComponent = ({
  focusedTopic,
  performScroll,
  topics,
  summaries,
  currentProduct
}) => {
  const groupedTopics = groupSubtopics(topics)
  return (
    <TopicsDetailContainer data-testid="topics-detail-container">
      <DetailsHardRule />
      <Grid container spacing={24} direction="column">
        <DetailsHeading data-testid={`${currentProduct.id}-important-info`}>
          {`${currentProduct.name} Important Information`}
        </DetailsHeading>
        <ProductSummary
          {...{
            summaries,
            performScroll,
            currentProduct
          }}
        />
      </Grid>
      <Grid container spacing={24}>
        <DetailsHeading>
          {`${currentProduct.name} Details`}
        </DetailsHeading>
        <TopicsDetailList {...{
          groupedTopics,
          focusedTopic
        }}
        />
      </Grid>
    </TopicsDetailContainer>
  )
}

export default TopicsDetailComponent
